import ticketActions from "./ticketActions";
const allActionsTicket = {
  ticketActions,
};

export default allActionsTicket;
